import React from 'react'
import { formatDateYYYYMMDD } from '../../packages/utils/numberFormatters'
import { Tooltip } from '@mui/material'

const formatSubscriptionPeriodsEndDates = (subscriptionPeriods) => {
    return subscriptionPeriods.map((period) => formatDateYYYYMMDD(period.subEndDate)).join(', ')
}

const formatWarrantSubEndDates = (warrant) => {
    if (!warrant) return ''

    const subEndDate = formatDateYYYYMMDD(warrant.subEndDate)

    return warrant.subscriptionPeriods?.length > 1 ? (
        <Tooltip arrow title={formatSubscriptionPeriodsEndDates(warrant.subscriptionPeriods)} placement='top'>
            <span>{subEndDate + ' *'}</span>
        </Tooltip>
    ) : (
        subEndDate
    )
}

function WarrantSubEndDate({ warrant }) {
    return <>{formatWarrantSubEndDates(warrant)}</>
}

export { WarrantSubEndDate, formatWarrantSubEndDates }
